import { render, staticRenderFns } from "./ConfigureInfo.vue?vue&type=template&id=1d22c7df&scoped=true&"
import script from "./ConfigureInfo.vue?vue&type=script&lang=js&"
export * from "./ConfigureInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d22c7df",
  null
  
)

export default component.exports